// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2sLX5","footer":"ModalInfo_footer__30bOs"};